/**
 * x_tarificador-cart-rates-preview.js
 * Orquestador principal del sistema de tarifas de envío
 * CORREGIDO: Permite cargar el Header aunque el carrito esté vacío
 */
(function() {
  'use strict';

  /* ========================================
     CONFIGURACIÓN Y CONSTANTES
     ======================================== */
  window.HACIENDOLA = window.HACIENDOLA || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS || {};
  
  // Obtener el shop URL del meta tag o del objeto Shopify
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.shopUrl = 
    window.Shopify?.shop || 
    document.querySelector('meta[property="og:url"]')?.content?.match(/https?:\/\/([^\/]+)/)?.[1] ||
    window.location.hostname || 
    '';
  
  /* CUSTOMIZABLE VALUES BEGIN */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.goToCheckoutButtonName = 'checkout';
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.cartCheckoutFormId = 'cart_form';
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.forceCitySelection = false;
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.showRates = true;
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.decimalValues = 0;
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.ignoredRatesCode = [];

  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues = {
    'SNIPPET TITLE': 'Comuna de envío',
    'LOADING TEXT': 'Cargando...',
    'CHOOSE PROVINCE TEXT': '¿Región?',
    'CHOOSE CITY TEXT': '',
    'FORCE SELECTION MESSAGE': 'Debes seleccionar una región y comuna antes de continuar.',
    'CALCULATING RATES': 'Calculando tarifas...',
    'NO RATES AVAILABLE': 'No hay tarifas disponibles para este carrito.',
    'AVAILABLE RATES': 'Tarifas disponibles',
    'SHIPPING COUNTRY': 'Chile',
  };
  /* CUSTOMIZABLE VALUES END */

  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.provincesWithCities = [];
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.dataLoaded = false;

  /* ========================================
     CONFIGURACIÓN DE EVENT LISTENERS (CORREGIDO)
     ======================================== */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupEventListeners = () => {
    // 1. Verificamos que tengamos datos de provincias cargados
    const provinces = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.provincesWithCities;
    if (!provinces || provinces.length === 0) return;

    // 2. Cargar selección guardada (LocalStorage)
    const savedSelection = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.loadSelection();

    // 3. INTENTO DE CARGA: Selectores del CARRITO
    // Solo intentamos configurarlos si existen en el DOM
    const provinceSelectCart = document.getElementById('pscCartDropdownProvinceSelect');
    const citySelectCart = document.getElementById('pscCartDropdownCitySelect');
    
    if (provinceSelectCart && citySelectCart) {
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupCartListeners(provinceSelectCart, citySelectCart, provinces, savedSelection);
    }

    // 4. INTENTO DE CARGA: Selectores del POPUP HEADER
    // Intentamos configurarlos independientemente de si el carrito existe o no
    if (window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupPopupListeners) {
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupPopupListeners(provinces, savedSelection);
    }
  };

  /* ========================================
     INICIALIZACIÓN
     ======================================== */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.init = () => {
    if (window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.dataLoaded) {
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupEventListeners();
    } else {
      const shopUrl = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.shopUrl;
      if (!shopUrl) {
        console.error('Shop URL not found');
        return;
      }

      fetch(
        `https://prod.haciendola.dev/backend/tarificadorww/api/provinces/getShopEnabledProvinces/${shopUrl}`
      )
        .then((response) => response.json())
        .then((result) => {
          window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.provincesWithCities = result;
          window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.dataLoaded = true;
          window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupEventListeners();
        })
        .catch(err => console.error('Error loading provinces:', err));
    }
  };

  /* ========================================
     ARRANQUE DEL SISTEMA
     ======================================== */
  const initialize = () => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.init);
    } else {
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.init();
    }

    // Escuchar actualizaciones del carrito
    document.addEventListener('cart:updated', () => {
      setTimeout(() => {
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.init();
      }, 800);
    });

    // Observar cambios en el DOM del carrito
    const observer = new MutationObserver(() => {
      const provinceSelect = document.getElementById('pscCartDropdownProvinceSelect');
      // Solo reiniciamos si detectamos cambios en el select del carrito, pero no bloqueamos el resto
      if (provinceSelect && (!provinceSelect.options || provinceSelect.options.length <= 1)) {
        setTimeout(() => {
          window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.init();
        }, 200);
      }
    });

    // Observar el cart drawer
    const observeCart = () => {
      const cartElement = document.querySelector('cart-items-component, .cart-drawer, [data-cart-drawer]');
      if (cartElement) {
        observer.observe(cartElement, { childList: true, subtree: true });
      } else {
        // Si no encuentra el carrito, reintentamos un par de veces pero no infinito para no saturar
        // setTimeout(observeCart, 500); 
        // Comentado para evitar bucles infinitos si no hay carrito en home
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeCart);
    } else {
      observeCart();
    }
    
    // Actualizar el header cuando se cargue la página
    setTimeout(() => {
        // Aseguramos que la función exista antes de llamarla
        if(window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton) {
            window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
        }
    }, 1000);
  };

  initialize();
})();